import classNames from 'classnames';
import { Component } from 'react';

import Icon, { icons } from '../../../generic/Icon';

type SortingHeaderItemProps = {
  currentSort: { asc: boolean; key: string };

  sortKey: string;

  onClick: (sortKey: string, asc: boolean) => void;
  children: any;
}

class SortingHeaderItem extends Component<SortingHeaderItemProps> {
  onClick = () => {
    // If this is the current sort, reverse sort order.
    const asc = (this.selected() ? !this.props.currentSort.asc : true);
    this.props.onClick(this.props.sortKey, asc);
  };

  selected = () => this.props.currentSort.key === this.props.sortKey;

  classNames = () => ({
    active: this.selected(),
  });

  render() {
    return (
      <th
        onClick={this.onClick}
        className={classNames('clickable sorting-header', this.classNames())}
      >
        {this.props.children}
        {
          this.selected() && (
            <Icon icon={this.props.currentSort.asc ? icons.caretUp : icons.caretDown} />
          )
        }
      </th>
    );
  }
}

export default SortingHeaderItem;
